<!-- eslint-disable vue/multi-word-component-names -->
<template functional lang="html">
  <button
    type="button"
    class="btn align-baseline btn-icon"
    :class="[data.class, data.staticClass]"
    :title="props.title"
    v-on="listeners"
    v-bind="data.attrs"
    :ref="data.ref"
  >
    <slot name="icon"><span :class="props.iconClass"></span></slot>
    <span class="visually-hidden"><slot>{{props.title}}</slot></span>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },

    iconClass: [Array, String]
  }
};
</script>
